import type { AnchorHTMLAttributes, ReactNode } from "react";

type BrandMarkProps = {
  href?: string;
  className?: string;
};

export function BrandMark({ href = "https://diffex.ai", className }: BrandMarkProps) {
  return (
    <a className={className} href={href} aria-label="Diffex home">
      diffex
    </a>
  );
}

type ActionLinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  children: ReactNode;
  tone?: "primary" | "secondary";
};

export function ActionLink({
  children,
  className = "",
  tone = "primary",
  ...props
}: ActionLinkProps) {
  return (
    <a className={`action-link action-link-${tone} ${className}`.trim()} {...props}>
      {children}
    </a>
  );
}
